const hasText = function (tableRow) {
  let name = $("#campaign_name").val();
  if (name.length == 0) {
    return true;
  }
  return $(tableRow).text().toLowerCase().indexOf(name) > 0;
};

const hasLogo = function (tableRow) {
  let checkedLogos = $(".campaign-filters input:checked");
  if (checkedLogos.length == 0) {
    return true;
  }

  let foundLogo = false;
  $(checkedLogos).each(function () {
    let logoName = $(this).val();
    if ($(tableRow).find("img[title=" + logoName + "]").length > 0) {
      foundLogo = true;
      return;
    }
  });
  return foundLogo;
};

const filterList = function () {
  $("#campaign-table tbody tr").filter(function () {
    $(this).toggle(hasText($(this)) && hasLogo($(this)));
  });
};

$(function () {
  // jQuery plugin, added to /vendor
  $("#campaign-table").tablesorter({
    cssAsc: "headerSortUp",
    cssDesc: "headerSortDown",
    cssHeader: "headerSort",
    widgets: ["saveSort"],
    widgetOptions: {
      saveSort: true,
    },
  });

  $("a[data-filter-toggle]").click(function () {
    $(".campaign-filters").toggle(400);
  });

  $("input[data-fundraiser-toggle]").click(function (event) {
    filterList();
  });

  $(".campaign-filters .typeahead").typeahead(null, {
    name: "campaigns",
    display: "value",
    source: filterList,
  });

  $(".campaign-filters .typeahead").on("input", function (event) {
    // typeahead won't fire when the input has zero chars (??)
    if (event.target.value.length == 0) {
      filterList();
    }
  });

  $("data[campaign_name_filter]").on("input", function (event) {
    // typeahead won't fire when the input has zero chars (??)
    if (event.target.value.length == 0) {
      filterList();
    }
  });

  $("a[data-clear-filters]").click(function () {
    $("#campaign_name").val("");
    $(".campaign-filters input:checked").attr("checked", false);
    filterList();
  });
});
